import { Controller } from "@hotwired/stimulus"

// Keeps both documentation indexes in sync with the section being read.
// The links remain ordinary anchors when JavaScript is unavailable.
export default class extends Controller {
  static targets = [ "link", "section" ]

  connect() {
    this.previousHash = null
    this.update()
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }

  select(event) {
    this.selectedSectionId = event.currentTarget.hash.slice(1)
    this.activate(this.selectedSectionId)
  }

  update() {
    const currentHash = window.location.hash.slice(1)
    if (currentHash !== this.previousHash) {
      this.previousHash = currentHash
      this.selectedSectionId = currentHash || null
    }

    if (this.frame) return

    this.frame = requestAnimationFrame(() => {
      this.frame = null
      this.activate(this.currentSection.id)
    })
  }

  get currentSection() {
    if (this.selectedSectionId) {
      const selectedSection = this.sectionTargets.find((section) =>
        section.id === this.selectedSectionId
      )
      const bounds = selectedSection?.getBoundingClientRect()

      if (bounds && bounds.bottom > 128 && bounds.top < window.innerHeight) {
        return selectedSection
      }

      this.selectedSectionId = null
    }

    if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
      return this.sectionTargets.at(-1)
    }

    return this.sectionTargets.filter((section) =>
      section.getBoundingClientRect().top <= 128
    ).at(-1) || this.sectionTargets[0]
  }

  activate(sectionId) {
    this.linkTargets.forEach((link) => {
      const active = link.hash === `#${sectionId}`

      link.toggleAttribute("data-active", active)
      if (active) {
        link.setAttribute("aria-current", "location")
      } else {
        link.removeAttribute("aria-current")
      }
    })
  }
}
